import styled from "styled-components";
import { apolloSpaceInsetHalfX } from "@nexthink/apollo-tokens";
export const StyledActionMenu = styled.div.withConfig({ displayName: "StyledActionMenu_APC-7281-productShell", componentId: "sc-13ydeoc" })(({ theme, $maxHeight }) => (Object.assign(Object.assign({ margin: 0, background: theme.colors.apolloColorBackgroundPopover, padding: `${apolloSpaceInsetHalfX} 0`, boxShadow: theme.colors.apolloBoxShadowTooltip, boxSizing: "border-box", maxHeight: $maxHeight }, ($maxHeight && {
    overflowY: "auto",
    overflowX: "hidden",
})), { "&[data-focus-visible-added]": {
        outline: "none !important",
    } })));
//# sourceMappingURL=ActionMenu.style.js.map